module.exports = __webpack_public_path__ + "img/1.269012d5.jpg";